<h2 mat-dialog-title>{{ 'CRM.USE_MESSAGING_TEMPLATE_TITLE' | translate }}</h2>
<mat-dialog-content>
  @if (state().status === 'loading') {
    <div class="template-picker-loading">
      <glxy-loading-spinner></glxy-loading-spinner>
    </div>
  }
  @if (state().status === 'error') {
    <p class="template-picker-message">{{ 'CRM.TEMPLATE_PICKER_LOAD_ERROR' | translate }}</p>
  }
  @if (state().status === 'loaded') {
    <div class="template-picker-toolbar">
      <glxy-form-field class="template-picker-search" [suffixIcon]="'search'" [showLabel]="false" [bottomSpacing]="'none'">
        <input matInput [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)" [placeholder]="'CRM.TEMPLATE_PICKER_SEARCH' | translate" />
      </glxy-form-field>
      <span class="template-picker-count">{{ filteredRows().length }} {{ 'CRM.TEMPLATE_PICKER_COUNT' | translate }}</span>
    </div>

    @if (filteredRows().length === 0) {
      <p class="template-picker-message">{{ 'CRM.TEMPLATE_PICKER_EMPTY' | translate }}</p>
      @if (createTemplateUrl) {
        <a mat-button [href]="createTemplateUrl" target="_blank" rel="noopener noreferrer">
          {{ 'CRM.TEMPLATE_PICKER_CREATE_CTA' | translate }}
        </a>
      }
    } @else {
      <div class="template-picker-grid">
        @for (template of filteredRows(); track template.emailBuilderEmailId) {
          <button class="template-card" type="button" (click)="selectTemplate(template)">
            <div class="template-card-thumbnail">
              @if (previewMap().get(template.emailBuilderEmailId); as srcdoc) {
                <div class="iframe-container">
                  <div class="iframe-overlay"></div>
                  <iframe
                    [srcdoc]="srcdoc"
                    sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                  ></iframe>
                </div>
              } @else {
                <mat-icon class="template-card-icon">email</mat-icon>
              }
            </div>
            <div class="template-card-meta">
              <span class="template-card-name">{{ displayLabel(template) }}</span>
              @if (template.updated) {
                <span class="template-card-date">{{ 'CRM.TEMPLATE_PICKER_UPDATED' | translate }} {{ template.updated | date: 'MMM d, yyyy' }}</span>
              }
            </div>
          </button>
        }
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()">
    {{ 'CRM.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
